/**
 * SiteHeader — shared top bar for public pages.
 *
 * Used on /tracks, /quotes, and any other public content page. NOT used on:
 *   - / (home) — has its own `~/home ▋` terminal-style label instead
 *   - /admin/* — uses the admin sidebar shell
 *   - /login, /accept-invite — have their own full-bleed layouts
 *
 * Props:
 *   - adminHref: if set, shows an "admin →" pill for admins that links here.
 *                Pass the destination you want (e.g. "/admin/tracks").
 */

import { Link } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext.jsx';
import DesktopNav from './DesktopNav.jsx';
import './SiteHeader.css';


export default function SiteHeader({ adminHref }) {
  const { user, logout } = useAuth();
  const userInitials = user ? user.display_name.slice(0, 2).toUpperCase() : '';

  return (
    <header className="site-header">
      <div className="site-header__left">
        <DesktopNav />
        <Link to="/" className="site-header__brand" title="back to home">
          <img
            src="/nachofiles-wordmark-small.png"
            alt="NachoFiles"
            className="site-header__wordmark"
          />
        </Link>
      </div>

      <div className="site-header__right">
        {user ? (
          <>
            {user.role === 'admin' && adminHref && (
              <Link to={adminHref} className="site-header__admin">
                admin →
              </Link>
            )}
            <Link to="/profile" className="site-header__avatar">
              {user.avatar_url
                ? <img src={`${user.avatar_url}?v=${Date.now()}`} alt="" style={{width:'100%',height:'100%',borderRadius:'50%',objectFit:'cover'}} />
                : userInitials
              }
            </Link>
            <div className="site-header__user-info">
              <div className="site-header__user-name">{user.display_name}</div>
              <div className="site-header__user-meta">
                @{user.username} · {user.role}
              </div>
            </div>
            <button className="site-header__logout" onClick={logout}>
              sign out
            </button>
          </>
        ) : (
          <Link to="/login" className="site-header__signin">
            sign in  →
          </Link>
        )}
      </div>
    </header>
  );
}
